import { render, staticRenderFns } from "./All_FAQ.vue?vue&type=template&id=0890342a&scoped=true&"
import script from "./All_FAQ.vue?vue&type=script&lang=js&"
export * from "./All_FAQ.vue?vue&type=script&lang=js&"
import style0 from "./All_FAQ.vue?vue&type=style&index=0&id=0890342a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890342a",
  null
  
)

export default component.exports